import { workflowAxiosPost } from "../utils/workflowAuthHeaders";

/**
 * @deprecated Use pedido-vendas-api (POST CRM_INCPV).
 * Mantido apenas para compatibilidade.
 */
const enviarRequisicao = async (requestBody, token, username, password) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest/";
  try {
    const response = await workflowAxiosPost(
      `${baseUrl}CRM_INCPV?empresa=01&filial=01`,
      requestBody,
      {},
      { token, username, password },
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar requisição:", error);
    throw error;
  }
};

export default enviarRequisicao;
